import dayjs from 'dayjs';

export const DEFAULT_BUILDING_VALUES = {
  id: null,
  name: '',
  square_footage: '',
  occupancy: '',
  address: {},
  not_physical: '',
  organization_id: null,
  reference_id: '',
  organization: { name: '' },
  utility_acconts: [],
  has_provider_account: false,
  building_type: null,
  benchmark_type: null,
  accounts: [],
  siblings: [],
};

export const DEFAULT_ACCOUNT_VALUES = {
  id: null,
  account_number: '',
  exclude_from_reports: '',
  account_type: '',
  organization: { id: null },
  utility_Provider: '',
  reference_id: '',
  reference_id2: '',
  sub_accounts: [],
  buildings: [],
  physical_buildings: [],
  available_masks: {},
  child_masks: [],
  parent_masks: [],
  parent_mask_sub_accounts: [],
  utility_template: {},
};


export function handleAdvancedAccountFiltering(accounts, accountSummaryFilterValue, accountOldFilerValue, accountIgnoreFilterValue, accountEmptyFilter) {
  if (parseInt(accountSummaryFilterValue) === 1) {
    accounts = accounts.filter((acc) => acc.is_masked === false)
  }
  if (parseInt(accountOldFilerValue) === 1) {
    const today = dayjs.utc(new Date())
    accounts = accounts.filter((acc) => !(acc.last_bill_date !== null && (today > dayjs.utc(acc.last_bill_date))))
  }
  if (parseInt(accountIgnoreFilterValue) === 1) {
    accounts = accounts.filter((acc) => acc.exclude_from_reports !== true)
  }
  if (parseInt(accountEmptyFilter) === 1) {
    accounts = accounts.filter((acc) => acc.max_bill_date !== null)
  }
  return accounts
}

export const consumption_keys = {
  0: { 'name': "Total Consumption", 'key': 'total_consumption' },
  1: { 'name': "Consumption 1 Value", 'key': 'consumption1_value' },
  2: { 'name': "Consumption 2 Value", 'key': 'consumption2_value' },
  3: { 'name': "Consumption 3 Value", 'key': 'consumption3_value' },
}

export const cost_keys = {
  0: { 'name': "Total Cost", 'key': 'total_cost' },
  1: { 'name': "Cost 1 Value", 'key': 'cost1_value' },
  2: { 'name': "Cost 2 Value", 'key': 'cost2_value' },
  3: { 'name': "Cost 3 Value", 'key': 'cost3_value' },
}